/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
var Datetime = require('react-datetime');
import ProtocoloTimeLineCliente from './ProtocoloTimeLineCliente';
import DetalharHistorico from './DetalharHistorico';
import Helpers from './util/Helpers';
import ConfigD from './util/ConfigD';
import './css/visualizarProtocolo.css';
import 'jquery-validation';
import Erro from './Erro';
import $ from 'jquery';

class VisualizarProtocolo extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            mensagem: null,
            historico: null
        };
        this.abrirPanel = this.abrirPanel.bind(this);

    }

    abrirPanel(mensagem, historico, texto) {

        //console.log('historico ', historico);
        //console.log('texto ', texto);
        this.setState({mensagem, historico});

        this.setState({visualizarHistorico:historico, texto:texto});
        if ($('.detailFoot').hasClass('slide-up')) {
            $('.detailFoot').addClass('slide-down', 1000, 'easeOutBounce');
            $('.detailFoot').removeClass('slide-up');
        } else {
            $('.detailFoot').removeClass('slide-down');
            $('.detailFoot').addClass('slide-up', 1000, 'easeOutBounce');
        }

        // if (this.validaForm()) {
        //    //console.log('validou')
        //     self = this
        //     var nome = $('#txtNome').val();
        //     var email = $('#txtEmail').val();

        //     var data = {
        //         nome: nome,
        //         email: email
        //     }
        //    //console.log('data - ', data);
        //     // this.props.actions.ObterMensagemPorProtocoloSenha(data).catch(error => {
        //     //     Alert.warning(!$.isEmptyObject(error.returnStatus)?error.returnStatus.description:'erro inesperado '+ error.statusText, {
        //     //         position: 'top-right',
        //     //         effect: 'slide',
        //     //         offset: 172,
        //     //         timeout: 5000
        //     //     });
        //     // });;

        // }


    }
    componentDidMount() {
        
    }
    
    componentWillReceiveProps(nextProps) {

        if (!$.isEmptyObject(nextProps.mensagem) && this.props.mensagem !== nextProps.mensagem) {
            //console.log('mensagem consultada', nextProps.mensagem)
            this.context.router.push(ConfigD.getServerBase() + '/visualizarProtocolo');
        }

    }

    render() {
        if ($.isEmptyObject(this.props.mensagem)){
            return <Erro mensagemErro='Página não encontrada!' />
        }
        //console.log('mensagem', this.props.mensagem)
    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <h2 className="title">Consultar protocolo</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>Consultar protocolo</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
                <div className="row">
                    {this.props.mensagem.dado.map((mensagem, index) =>
                        <div className='row' key={index}>
                            <ProtocoloTimeLineCliente mensagem={mensagem} key={mensagem.mIdMensagem} abrirPanel={this.abrirPanel}/>
                        </div>
                    )}
                </div>
                <DetalharHistorico mensagem={this.state.mensagem} historico={this.state.historico} texto={this.state.texto}/>    
            </div>
        </div>
    );
  }
}

VisualizarProtocolo.protoType = {
    //actionCliente: PropTypes.object.isRequired
}
VisualizarProtocolo.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        mensagem: state.mensagem
    };
}

function mapDispatchToProps(dispatch){
   return {
      
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizarProtocolo);



/** WEBPACK FOOTER **
 ** ./src/components/VisualizarProtocolo.js
 **/